const ACTIONS = {
    GET_DATA_SUCCESS: 'GET_DATA_SUCCESS',
    GET_DATA_ERROR: 'GET_DATA_ERROR',
    GET_INFO_TEAM_1_SUCCESS: 'GET_INFO_TEAM_1_SUCCESS',
    GET_INFO_TEAM_1_ERROR: 'GET_INFO_TEAM_1_ERROR'
};

const headerBattingAvgTable = ['順位', '選手名', '打率'];
const titleBattingAvgTable = {
    dot: false,
    text: '打率',
};
const mockDataBattingAvgTable = [
    {
        item: [
            { text: 1 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 2 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 3 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
];

const headerHomeRunTable = ['順位', '選手名', '本塁打数']
const titleHomeRunTable = {
    dot: false,
    text: '本塁打',
};
const mockDataHomeRunTable = [
    {
        item: [
            { text: 1 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 2 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 3 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 3 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
];

const headerRBITable = ['順位', '選手名', '打点']
const titleRBITable = {
    dot: false,
    text: '打点',
};
const mockDataRBITable = [
    {
        item: [
            { text: 1 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 2 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 3 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
];

const headerStealTable = ['順位', '選手名', '盗塁']
const titleStealTable = {
    dot: false,
    text: '盗塁',
};
const mockDataStealTable = [
    {
        item: [
            { text: 1 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 2 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
    {
        item: [
            { text: 3 },
            { text: '坂本 勇人', img: 'img/team/Giants.png' },
            { text: '.314' },
        ],
    },
];

export default (state = {
    headerBattingAvgTable, titleBattingAvgTable,
    mockDataBattingAvgTable, headerHomeRunTable, titleHomeRunTable,
    mockDataHomeRunTable, headerRBITable, titleRBITable, mockDataRBITable,
    headerStealTable, titleStealTable, mockDataStealTable
}, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data.data,
            };
        case ACTIONS.GET_INFO_TEAM_1_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS.GET_DATA_ERROR:
        case ACTIONS.GET_INFO_TEAM_1_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};